module.exports = __webpack_public_path__ + "static/media/m_eyeshape_round_hazel.439e1fa8.png";